import { render, staticRenderFns } from "./AddOrg.vue?vue&type=template&id=2d68db5c&scoped=true"
import script from "./AddOrg.vue?vue&type=script&lang=js"
export * from "./AddOrg.vue?vue&type=script&lang=js"
import style0 from "./AddOrg.vue?vue&type=style&index=0&id=2d68db5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68db5c",
  null
  
)

export default component.exports